<template>
    <div class="edit-profile-detail">
        <div class="title">결정사 사용경험</div>
        <div class="sub-title">결혼정보회사를 사용해 본 적이 있나요?</div>
        <div class="section">
            <div class="column">
                <div
                    class="item"
                    :class="{ selected: item.id === selectedIdx }"
                    v-for="item in items"
                    :key="item.id"
                    v-html="item.name"
                    @click="onClickItem(item.id)"
                />
            </div>
        </div>
    </div>
</template>

<script>
import signupConstant from '@/assets/constants/onboard-temp-signup'

export default {
    name: 'UseManager',
    computed: {
        tempSignupPayload() {
            return JSON.parse(localStorage.getItem('tempSignupPayload')) || {}
        },
        items() {
            return signupConstant.useManager
        },
        disabled() {
            return this.selectedIdx === null
        },
    },
    data: () => ({
        selectedIdx: null,
    }),
    methods: {
        onClickItem(idx) {
            this.selectedIdx = idx

            setTimeout(() => this.next(), 200)
        },
        next() {
            const payload = { ...this.tempSignupPayload, use_manager: this.selectedIdx }
            localStorage.setItem('tempSignupPayload', JSON.stringify(payload))

            this.$router.push({ name: 'OnboardWhyDifficult' })
        },
    },
    mounted() {
        this.selectedIdx = this.tempSignupPayload.use_manager
        if (this.tempSignupPayload.use_manager === undefined) {
            this.$nativeBridge.postMessage({
                action: 'sendFirebaseEvent',
                value: {
                    category: `Enter_UseCompanyPage`,
                },
            })
        }
    },
}
</script>

<style scoped lang="scss"></style>
